import NotificationView from '@/template/views/NotificationView.vue';
export var notificationRoutes = [
    {
        name: 'generalNotification',
        path: '/generalNotification/:id',
        component: NotificationView,
        meta: {
            mainNav: false,
            title: 'Forms.GeneralNotification',
            recordableType: 'GeneralNotification',
            type: 'generalNotification'
        }
    },
    {
        name: 'transferredAmountNotification',
        path: '/transferredAmountNotification/:id',
        component: NotificationView,
        meta: {
            mainNav: false,
            title: 'Forms.TransferredAmountNotification',
            recordableType: 'TransferredAmountNotification',
            type: 'transferredAmountNotification'
        }
    },
    {
        name: 'inspectionVisitNotification',
        path: '/inspectionVisitNotification/:id',
        component: NotificationView,
        meta: {
            mainNav: false,
            title: 'Forms.InspectionVisitNotification',
            recordableType: 'InspectionVisitNotification',
            type: 'inspectionVisitNotification'
        }
    },
];
